import { DetailsHeader, NotFoundMessage, Segments } from "components";
import { Routes, Route, Navigate } from "react-router";
import { GoogleFiles } from "./files/GoogleFiles";
import { GoogleMeetings } from "./meetings/GoogleMeetings";
import { GoogleCollaborations } from "./collaboration/GoogleCollaborations";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";

import styles from "./googleReport.module.scss";

const pages = [
  { to: "files", label: "Files" },
  { to: "meetings", label: "Meetings" },
  { to: "collaborations", label: "Collaborations" },
];

export const GoogleReport = () => {
  const isGoogleReportingEnabled = !!useFeatureFlag(FeatureFlags.GoogleReports);

  if (!isGoogleReportingEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="nested-content">
      <DetailsHeader title="Google Graph" showReportLastUpdated />
      <Segments to="/reporting/google">
        {pages.map((page) => (
          <Segments.Segment {...page} key={page.label} />
        ))}
      </Segments>
      <div className={styles.scrolling}>
        <Routes>
          <Route path="files" element={<GoogleFiles />} />
          <Route path="meetings" element={<GoogleMeetings />} />
          <Route path="collaborations" element={<GoogleCollaborations />} />
          <Route index element={<Navigate to="files" />} />
          <Route path="*" element={<NotFoundMessage />} />
        </Routes>
      </div>
    </div>
  );
};
